import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import DatePicker from './components/DatePicker';

const SummerRange: React.FC<{
  summerTime: [string, string];
  setSummerTime: React.Dispatch<React.SetStateAction<[string, string]>>;
}> = ({ summerTime, setSummerTime }) => {
  const [startMonth, setStartMonth] = useState<string>(
    summerTime[0].split('-')[0]
  );
  const [startDay, setStartDay] = useState<string>(summerTime[0].split('-')[1]);
  const [endMonth, setEndMonth] = useState<string>(summerTime[1].split('-')[0]);
  const [endDay, setEndDay] = useState<string>(summerTime[1].split('-')[1]);

  useEffect(() => {
    const start = summerTime[0].split('-');
    const end = summerTime[1].split('-');
    setStartMonth((prev) => (prev !== start[0] ? start[0] : prev));
    setStartDay((prev) => (prev !== start[1] ? start[1] : prev));
    setEndMonth((prev) => (prev !== end[0] ? end[0] : prev));
    setEndDay((prev) => (prev !== end[1] ? end[1] : prev));
  }, [summerTime]);

  useEffect(() => {
    setSummerTime([`${startMonth}-${startDay}`, `${endMonth}-${endDay}`]);
  }, [startMonth, startDay, endMonth, endDay, setSummerTime]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          夏季開始時間
        </Typography>
        <DatePicker
          {...{
            month: startMonth,
            setMonth: setStartMonth,
            day: startDay,
            setDay: setStartDay,
          }}
        />
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          夏季結束時間
        </Typography>
        <DatePicker
          {...{
            month: endMonth,
            setMonth: setEndMonth,
            day: endDay,
            setDay: setEndDay,
          }}
        />
      </Box>
    </Box>
  );
};

export default React.memo(SummerRange);
